export class CommonConstants {
    public static readonly MAX_TOTAL_FILE_SIZE = 50
    public static readonly PARCELS_LIMIT_SHP_EXPORT = 30000
    public static readonly PARCELS_LIMIT_XLSX_EXPORT = 30000
    public static readonly PARCELS_LIMIT_LV_EXPORT = 100
    public static readonly MAP_PARCELS_LIST_LIMIT = 10000
    public static readonly BUILDINGS_LIST_LIMIT = 10000
    public static readonly MAX_CONTRACT_BULK_ACTION_CONTRACTS = 500
    public static readonly EMAIL_REGEX = new RegExp('^([a-z0-9]+[a-z0-9\\._%\\-+]*)@([a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,17})$')
}